import React, { useEffect } from 'react';
import Button from '../../atoms/button/Button';
import { BackIcon, ForwardIcon } from '../../assets/Icons';
import PreviewCanvas from '../preview-canvas/PreviewCanvas';
import { useDispatch } from 'react-redux';
import { getValue } from '../../pages/utils/tools';
import {
  setCompleted
} from '../../../redux/walkthroughPreviewSlice';
import { RenderEscapedString } from '../../pages/utils/tools';
import DOMPurify from 'dompurify';

// Step instructions/notes are authored as rich text (BL-143). Render them as
// sanitized HTML; plain-text legacy values still render correctly (newlines are
// converted to <br> for backward compatibility).
const richHtml = (value) => DOMPurify.sanitize(String(value || '').replace(/\n/g, '<br>'));

const Screen = ({ onChange, onActionBtn, configColors, steps, index, embed, id }) => {
  const dispatch = useDispatch();
  const currPage = steps[index] || {
    name: '',
    title: '',
    description: '',
    backgroundUrl: require('../../assets/loader.svg')
  };
  const { name, title, description } = currPage;

  // colors
  const tnBGColor = getValue(configColors, 'tn', 'tnBGColor');
  const tnTextColor = getValue(configColors, 'tn', 'tnTextColor');
  const mcaBGColor = getValue(configColors, 'mca', 'mcaBgColor');
  const mcaStepHeadlineFont = getValue(
    configColors,
    'mca',
    'mcaStepHeadlineFont'
  );
  const mcaStepHeadlineFontSize = getValue(
    configColors,
    'mca',
    'mcaStepHeadlineFontSize'
  );
  const mcaStepHeadlineColor = getValue(
    configColors,
    'mca',
    'mcaStepHeadlineColor'
  );
  const mcaStepDescriptionFont = getValue(
    configColors,
    'mca',
    'mcaStepDescriptionFont'
  );
  const mcaStepDescriptionFontSize = getValue(
    configColors,
    'mca',
    'mcaStepDescriptionFontSize'
  );
  const mcaStepDescriptionColor = getValue(
    configColors,
    'mca',
    'mcaStepDescriptionColor'
  );

  const mcaInstructionFont = getValue(
    configColors,
    'mca',
    'mcaInstructionFont'
  );

  const mcaInstructionFontSize = getValue(
    configColors,
    'mca',
    'mcaInstructionFontSize'
  );

  const mcaInstructionColor = getValue(
    configColors,
    'mca',
    'mcaInstructionColor'
  );
  const eaBGColor = getValue(configColors, 'ea', 'eaBGColor');
  const eaTextColor = getValue(configColors, 'ea', 'eaTextColor');

  const colors = {
    primary: tnBGColor || configColors.primary,
    background: tnBGColor || configColors.background,
    text: tnTextColor || configColors.text,
    border: tnBGColor || configColors.border
  };

  useEffect(() => {
    // dispatch(embed ? setEmbedActiveStep({data: currPage, id: id}) : setActiveStep(currPage));
  }, [currPage]);

  const prevPage = () => {
    if (index === 0) return;
    onActionBtn(index - 1);
  };

  const nextPage = () => {
    if (index === steps.length - 1){
      dispatch(setCompleted(true));
      return;
    }
    onActionBtn(index + 1);
  };

  const renderActionBtn = () => {
    const nextLabel = index === steps.length - 1 ? 'Finish' : 'Next';
    return (
      <div className="action-btn mb-32">
        <Button
          className="btn primary ghost"
          onClick={prevPage}
          configColors={colors}
        >
          <BackIcon />
          Back
        </Button>
        <Button
          className="btn primary"
          onClick={nextPage}
          configColors={colors}
        >
          {nextLabel}
          <ForwardIcon />
        </Button>
      </div>
    );
  };

  const style = {
    color: configColors.text,
    backgroundColor: mcaBGColor || configColors.background
  };

  const stepStyle = {
    color: mcaStepHeadlineColor || configColors.text,
    fontFamily: mcaStepHeadlineFont,
    fontSize: mcaStepHeadlineFontSize
  };

  const titleStyle = {
    color: mcaStepDescriptionColor || configColors.text,
    fontFamily: mcaStepDescriptionFont,
    fontSize: mcaStepDescriptionFontSize
  };

  const instructionStyle = {
    color: mcaInstructionColor || configColors.background,
    fontSize: mcaInstructionFontSize,
    fontFamily: mcaInstructionFont
  };

  return (
    <div className="content-screen">
      <div className="container mb-32" style={style}>
        <p className="step mb-32" style={stepStyle}>
          {name}
        </p>
        <p className="title mb-12" style={titleStyle}>
          {title}
        </p>
        <p
          className="subtitle mb-12"
          style={instructionStyle}
          dangerouslySetInnerHTML={{ __html: richHtml(description) }}
        />
        {currPage.notes ? (
          <div
            className="step-notes mb-12"
            style={instructionStyle}
            dangerouslySetInnerHTML={{ __html: richHtml(currPage.notes) }}
          />
        ) : null}
        <div className='preview-wrapper'>
          <PreviewCanvas configColors={configColors} embed={embed} id={id} step={currPage} onChange={onChange} />
        </div>
      </div>
      {renderActionBtn()}
    </div>
  );
};

export default Screen;
